import React from 'react'
import PropTypes from 'prop-types'

import './style.css.scss'

const CategoryNavigation = (props) => {
  const {
    selectedCategory, categoryIds, onClick, themeColorHex
  } = props

  const handleNextCategoryClick = () => {
    let nextCategoryIndex = categoryIds.indexOf(selectedCategory.id) + 1
    if(nextCategoryIndex > categoryIds.length - 1) {
      nextCategoryIndex = 0
    }
    onClick(categoryIds[nextCategoryIndex])
  }

  const handlePrevCategoryClick = () => {
    let prevCategoryIndex = categoryIds.indexOf(selectedCategory.id) - 1
    if(prevCategoryIndex < 0) {
      prevCategoryIndex = categoryIds.length - 1
    }
    onClick(categoryIds[prevCategoryIndex])
  }

  const hasNav = categoryIds.length > 1
  const themeStyle = { color: themeColorHex }

  return (
    <section className="category-navigation">
      { hasNav && (
        <span
          className='icon-chevron-left'
          onClick={handlePrevCategoryClick}
          style={themeStyle} />
      )}
      <h1 style={themeStyle}>{selectedCategory.name}</h1>
      { hasNav && (
        <span
          className='icon-chevron-right'
          onClick={handleNextCategoryClick}
          style={themeStyle} />
      )}
    </section>
  )
}

CategoryNavigation.propTypes = {
  selectedCategory: PropTypes.object.isRequired,
  categoryIds: PropTypes.array,
  onClick: PropTypes.func,
  themeColorHex: PropTypes.string
}

export default CategoryNavigation
